import React from "react";
import "./replace-card-form.css";
import CustomModal from "components/custom-modal/CustomModal";
import CustomForm from "components/custom-form/CustomForm";
import Button from "components/button/Button";
import { XIconV1 } from "images/image-component";
import LoadingModal from "modals/loading/LoadingModal";
import ErrorModal from "modals/error-modal/ErrorModal";
import SuccessModal from "modals/success-modal/SuccessModal";
import { useReplaceCard } from "./useReplaceCard";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  /** The card being replaced — seeds the "Old Card Number" field. */
  cardNumber: string;
}

function ReplaceCardForm({ isOpen, onClose, cardNumber }: Props) {
  const {
    fields,
    submitRef,
    isSubmitDisabled,
    showLoading,
    loadingMsg,
    showError,
    errorMsg,
    showSuccess,
    successMsg,
    successWarning,
    handleSubmit,
    handleRetry,
    handleCloseError,
    handleCloseSuccess,
  } = useReplaceCard(cardNumber);

  const handleSuccessClose = () => {
    handleCloseSuccess();
    onClose();
  };

  return (
    <>
      <CustomModal isOpen={isOpen} handleClose={onClose}>
        <button
          className="v1-modal-close"
          aria-label="Close"
          onClick={onClose}
          disabled={showLoading}
        >
          <XIconV1 />
        </button>

        <div className="rcf-header">
          <h2 className="v1-modal-title">Replace Card</h2>
          <p className="v1-modal-subtitle">
            The new card takes over the old card&apos;s wallet and balance.
            The old card is revoked and cannot be used again.
          </p>
        </div>

        <CustomForm fields={fields} />

        <div className="v1-modal-actions">
          <Button variant="ghost" onClick={onClose} disabled={showLoading}>
            Cancel
          </Button>
          <Button
            ref={submitRef}
            onClick={handleSubmit}
            disabled={isSubmitDisabled || showLoading}
          >
            Replace
          </Button>
        </div>
      </CustomModal>

      <LoadingModal isOpen={showLoading} loadingMsg={loadingMsg} />

      <ErrorModal
        isOpen={showError}
        errorMsg={errorMsg}
        handleClose={handleCloseError}
        tryAgain={handleRetry}
      />

      <SuccessModal
        isOpen={showSuccess}
        message={successMsg}
        warning={successWarning}
        handleClose={handleSuccessClose}
      />
    </>
  );
}

export default ReplaceCardForm;
